import useOnWindowFocus from '@/hooks/useWindowFocus';
import { useState, useEffect } from 'react';
import { LIMIT_OF_SELECTED_ITEMS } from './types';
import { cookieStorage } from '@/services/cookie';
import config from 'config-base';
import { getQueryData } from './getQueryData';

const useCompare = (initialData: Array<string>) => {
  const [compareData, setCompareData] = useState<Array<string>>(initialData);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const { isWindowFocused } = useOnWindowFocus();

  const handleCloseAlertPopup = () => {
    setShowAlertPopup(false);
  }

  const calcItemsIds = () => {
    const urls = compareData ? `${compareData.map((item) => item.match(/\d/g)?.join('')).join('/')}` : '';
    const afterId = compareData && compareData.length > 0 ? compareData[0]?.split('PY-')[1] : '';
    const isNumber = /^-?\d+$/.test(afterId);

    return { urls, afterId, isNumber };
  };

  const handleRedirectCompare = () => {
    const { urls, afterId, isNumber } = calcItemsIds();
    if (isNumber) {
      window.location.href = `${config.mainPyramydairUrl}/compare/G/${urls}`;
    } else {
      window.location.href = `${config.mainPyramydairUrl}/compare/${afterId[0]}/${urls}`;
    }
  };

  const setCompareCookie = async () => {
    try {
      const { urls, afterId, isNumber } = calcItemsIds();
      if (!urls) {
        await cookieStorage.remove({ key: 'compareList' });
        return;
      }
      if (isNumber) {
        await cookieStorage.put({ key: 'compareList', value: `G/${urls}/`, options: { expires: 1 } });
      } else {
        await cookieStorage.put({ key: 'compareList', value: `${afterId[0]}/${urls}/`, options: { expires: 1 } });
      }
    } catch (error) {
      console.log('cant handle cookie in compare search results', error);
    }
  };

  const showModalIfLimitsOfItems = () => {
    if (compareData && compareData.length === LIMIT_OF_SELECTED_ITEMS) {
      setShowAlertPopup(true);
    }
  };

  const handleCompare = (itemId: string, val: boolean) => {
    const numb = itemId.replace(/\d/g, '');
    if (!val) {
      setCompareData(compareData?.filter((id: string) => id !== itemId) || []);
      return;
    }

    const equalProductType = compareData?.every((itemId) => itemId.replace(/\d/g, '') === numb);
    if (!equalProductType) {
      setCompareData([itemId]);
      return;
    }

    if (compareData) {
      if (compareData.length === LIMIT_OF_SELECTED_ITEMS) {
        showModalIfLimitsOfItems();
        return;
      }
      setCompareData([...compareData, itemId]);
    } else {
      setCompareData([itemId]);
    }
  };

  const isSelectedToCompare = (compareData: Array<string> | undefined, itemId: string): boolean => {
    const isSelected = compareData ? compareData.indexOf(itemId) : -1;
    return isSelected <= LIMIT_OF_SELECTED_ITEMS && isSelected > -1;
  };

  const setCompareState = async () => {
    const compareList = (await cookieStorage.get('compareList')).data || '';
    const data = getQueryData(compareList);
    setCompareData(data);
  };

  useEffect(() => {
    if (isWindowFocused) {
      setCompareState();
    }
  }, [isWindowFocused]);

  useEffect(() => {
    if (compareData && compareData.length <= LIMIT_OF_SELECTED_ITEMS) {
      setCompareCookie();
    }
  }, [compareData]);

  return { compareData, isSelectedToCompare, handleCompare, handleRedirectCompare, showAlertPopup, handleCloseAlertPopup };
};

export default useCompare;
